import { render, staticRenderFns } from "./vueActiveProduct.vue?vue&type=template&id=c57604d4"
import script from "./vueActiveProduct.vue?vue&type=script&lang=js"
export * from "./vueActiveProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports